import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'
import _imports_1 from '@/assets/images/add&new-icon.svg'
import _imports_2 from '@/assets/images/copy-icon.svg'
import _imports_3 from '@/assets/images/submit-icon-1.svg'
import _imports_4 from '@/assets/images/create-package-icon.svg'
import _imports_5 from '@/assets/images/release-icon.svg'
import _imports_6 from '@/assets/images/revision-icon.svg'
import _imports_7 from '@/assets/images/delete-iocn.svg'
import _imports_8 from '@/assets/images/cancel-icon.svg'
import _imports_9 from '@/assets/images/withdraw-icon.svg'
import _imports_10 from '@/assets/images/approval-icon.svg'
import _imports_11 from '@/assets/images/export-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-e54f6752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchMain bg-fff m-t-8" }
const _hoisted_2 = { class: "d-f" }
const _hoisted_3 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Period", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "BU", -1))
const _hoisted_8 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Name", -1))
const _hoisted_10 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Brand", -1))
const _hoisted_12 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Type Class", -1))
const _hoisted_14 = {
  class: "flex-w-auto",
  style: {"padding-top":"25px","flex":"1.5"}
}
const _hoisted_15 = { class: "f-r" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Expand ")
const _hoisted_19 = { class: "d-f m-t-16" }
const _hoisted_20 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Status", -1))
const _hoisted_22 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Code", -1))
const _hoisted_24 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Category", -1))
const _hoisted_26 = { class: "d-f flex-w-auto flex-d-c m-l-16" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "SIPO Confirm Status", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_29 = {
  class: "d-f m-t-16 flex-w-auto",
  style: {"min-height":"40px"}
}
const _hoisted_30 = { class: "d-f search-btns" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Collapse ")
const _hoisted_34 = { class: "main bg-fff m-t-8 flex-w-auto d-f flex-d-c" }
const _hoisted_35 = { class: "d-f justify-b" }
const _hoisted_36 = { class: "d-f" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("My Program")
const _hoisted_38 = { class: "d-f" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "table-wrapper flex-w-auto m-t-16" }
const _hoisted_41 = ["title"]
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Log")
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#767676"} }, "Input a comment", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_TableWrapper = _resolveComponent("TableWrapper")!
  const _component_program_preview = _resolveComponent("program-preview")!
  const _component_ShowCommentsModel = _resolveComponent("ShowCommentsModel")!
  const _component_WordingBudget = _resolveComponent("WordingBudget")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_main_wrapper, { className: "p-l-r-10" }, {
      header: _withCtx(() => [
        _createVNode(_component_breadcrumb, { dataSource: [] })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_a_range_picker, {
                style: { width: 100 + '%' },
                value: [_ctx.periodFrom, _ctx.periodTo],
                format: "YYYY-MM-DD",
                onChange: _ctx.handlerPeriodChange,
                valueFormat: "YYYY-MM-DD",
                placeholder: ['Start Time', 'End Time']
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_a_select, {
                value: _ctx.bu,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bu) = $event)),
                mode: "multiple",
                showArrow: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buOptions, (item, index) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.orgid,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.orgnmen), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])), [
                      [_vShow, !item.parentBu]
                    ])
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_input, {
                value: _ctx.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_a_select, {
                value: _ctx.brand,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.brand) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.nameEN), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_select, {
                value: _ctx.typeClass,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.typeClass) = $event)),
                "show-search": "",
                "option-filter-prop": "children",
                "filter-option": _ctx.filterOption
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClassOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option"])
            ], 512), [
              [_vShow, _ctx.isOpen]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.$btnPermissions('RESET'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "m-l-16",
                      onClick: _ctx.handlerResetClick
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('SEARCH'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      class: "m-l-16",
                      type: "primary",
                      onClick: _ctx.handlerSearchClick
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: _ctx.handleCollapse,
                  style: {"padding-right":"0"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createElementVNode("i", {
                      class: _normalizeClass(["font_family m-l-5 v-align-1", _ctx.isOpen ? 'icon-xiangshang' : 'icon-xiangxia'])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ], 512), [
              [_vShow, !_ctx.isOpen]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_a_select, {
                value: _ctx.status,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programStatusOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.display), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_a_input, {
                value: _ctx.code,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.code) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_a_select, {
                value: _ctx.programCategory,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.programCategory) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programCategoryOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.offerTypeKey,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.offerTypeName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_a_select, {
                value: _ctx.sipoConfirmStatus,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sipoConfirmStatus) = $event)),
                mode: "multiple"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sipoConfirmStatusOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _hoisted_28
          ], 512), [
            [_vShow, _ctx.isOpen]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_29, null, 512), [
            [_vShow, _ctx.isOpen]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_30, [
            _createVNode(_component_a_button, {
              class: "m-l-16",
              onClick: _ctx.handlerResetClick
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              class: "m-l-16",
              type: "primary",
              onClick: _ctx.handlerSearchClick
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "link",
              onClick: _ctx.handleCollapse
            }, {
              default: _withCtx(() => [
                _hoisted_33,
                _createElementVNode("i", {
                  class: _normalizeClass(["font_family m-l-5 v-align-1", _ctx.isOpen ? 'icon-xiangshang' : 'icon-xiangxia'])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 512), [
            [_vShow, _ctx.isOpen]
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.mine,
                "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mine) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.$btnPermissions('SUBMIT'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "m-l-12",
                    to: "/programdesign/design",
                    title: "New"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('COPY'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "cursor-p m-l-12",
                    src: _imports_2,
                    title: "Copy",
                    alt: "",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handlerCopyClick && _ctx.handlerCopyClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('SUBMIT'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    class: "cursor-p m-l-12",
                    title: "Submit",
                    src: _imports_3,
                    alt: "",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handlerSubmitClick && _ctx.handlerSubmitClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('PACKAGE'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    class: "cursor-p m-l-12",
                    title: "Create Package",
                    src: _imports_4,
                    alt: "",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handlerCreatePackageClick && _ctx.handlerCreatePackageClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('SET'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 4,
                    class: "cursor-p m-l-12",
                    title: "Release Set",
                    src: _imports_5,
                    alt: "",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handlerReleaseSetClick && _ctx.handlerReleaseSetClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('REVISION'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 5,
                    class: "cursor-p m-l-12",
                    title: "Revision",
                    style: {"width":"20px"},
                    src: _imports_6,
                    alt: "",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handlerRevisionClick && _ctx.handlerRevisionClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('DELETE'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 6,
                    class: "cursor-p m-l-12",
                    title: "Delete",
                    style: {"width":"20px"},
                    src: _imports_7,
                    alt: "",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handlerDeleteClick && _ctx.handlerDeleteClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('CANCEL'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 7,
                    class: "cursor-p m-l-12",
                    title: "Cancel",
                    style: {"width":"20px"},
                    src: _imports_8,
                    alt: "",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handlerCancelClick && _ctx.handlerCancelClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('Call Back'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 8,
                    class: "cursor-p m-l-12",
                    title: "Callback",
                    style: {"width":"20px"},
                    src: _imports_9,
                    alt: "",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handlerWithdrawClick && _ctx.handlerWithdrawClick(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('CONFIRM'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 9,
                    class: "cursor-p m-l-12",
                    title: "Confirm",
                    style: {"width":"20px"},
                    src: _imports_10,
                    alt: "",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handlerConfirm && _ctx.handlerConfirm(...args)))
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('EXPORT'))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 10,
                    class: "cursor-p m-l-12",
                    title: "Export",
                    style: {"width":"20px"},
                    src: _imports_11,
                    alt: "",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handlerExport && _ctx.handlerExport(...args)))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_TableWrapper, { visible: _ctx.visible }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  class: "tab-container default-self-table-text",
                  dataSource: _ctx.data,
                  columns: _ctx.columns,
                  pagination: false,
                  "row-selection": _ctx.rowSelection,
                  scroll: { y: _ctx.tableHeight, x: 1500 },
                  customRow: _ctx.customRow,
                  rowClassName: 
              (record, index) =>
                index === _ctx.currentClickRowIndex ? 'table-highlight' : index % 2 === 1 ? 'table-striped' : null
            ,
                  rowKey: (item, index) => index
                }, {
                  programCode: _withCtx(({ text }) => [
                    _createElementVNode("span", {
                      class: "ellipsis ds-block",
                      style: {"width":"140px"},
                      title: text
                    }, _toDisplayString(text), 9, _hoisted_41)
                  ]),
                  programName: _withCtx(({ record, text }) => [
                    _createVNode(_component_router_link, {
                      onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
                      class: "ellipsis ds-block",
                      style: {"width":"400px"},
                      title: text,
                      to: {
                  path: '/programdesign/design',
                  query: { pgmId: record.programId }
                }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "to"])
                  ]),
                  batchApproveName: _withCtx(({ text, record }) => [
                    _createVNode(_component_router_link, {
                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
                      class: "ellipsis ds-block",
                      title: text,
                      to: `/approval/sales/createPackage?batchId=${record.batchId}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "to"])
                  ]),
                  batchReleaseName: _withCtx(({ text, record }) => [
                    _createVNode(_component_router_link, {
                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                      class: "ellipsis ds-block",
                      title: text,
                      to: `/approval/sales/releaseSetting?releaseId=${record.releaseId}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text), 1)
                      ]),
                      _: 2
                    }, 1032, ["title", "to"])
                  ]),
                  statusLog: _withCtx(({ record }) => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: _withModifiers(($event: any) => (_ctx.handleLogClick(record)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  batchprogramStatus: _withCtx(({ text, record }) => [
                    (text === 'Cancel Requested' || text === 'Callback Requested')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.handleShowComments(record.programId, record.programStatus)), ["stop"])
                        }, _toDisplayString(text), 9, _hoisted_43))
                      : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(text), 1))
                  ]),
                  combinabilityStatus: _withCtx(({ text }) => [
                    (text === 'ToBeConfirmed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "To Be Confirmed"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(text), 1))
                  ]),
                  parameterStatus: _withCtx(({ text }) => [
                    (text === 'ToBeConfirmed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "To Be Confirmed"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(text), 1))
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "row-selection", "scroll", "customRow", "rowClassName", "rowKey"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_program_preview, {
              visible: _ctx.visible,
              "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.visible) = $event)),
              program: _ctx.programPreviewData,
              "onUpdate:program": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.programPreviewData) = $event))
            }, null, 8, ["visible", "program"])
          ])
        ]),
        _createVNode(_component_ShowCommentsModel, {
          callBackTextVisible: _ctx.callBackTextVisible,
          "onUpdate:callBackTextVisible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.callBackTextVisible) = $event)),
          comments: _ctx.comments
        }, null, 8, ["callBackTextVisible", "comments"]),
        (_ctx.visiblePreview)
          ? (_openBlock(), _createBlock(_component_WordingBudget, {
              key: 0,
              wordingpreviewvisible: _ctx.visiblePreview,
              "onUpdate:wordingpreviewvisible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.visiblePreview) = $event))
            }, null, 8, ["wordingpreviewvisible"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_modal, {
          visible: _ctx.callBackVisible,
          "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.callBackVisible) = $event)),
          title: "Notice",
          "ok-text": "Confirm",
          "cancel-text": "Cancel",
          onCancel: _ctx.cancelModel,
          onOk: _ctx.hideModal
        }, {
          default: _withCtx(() => [
            _hoisted_49,
            _createVNode(_component_a_textarea, {
              value: _ctx.callbackText,
              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.callbackText) = $event)),
              placeholder: "Please input",
              rows: 2
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["visible", "onCancel", "onOk"]),
        _createVNode(_component_Pagination, {
          onChange: _ctx.handlerPaginationChange,
          onShowSizeChange: _ctx.handlerShowSizeChange,
          pageSize: _ctx.pagination.pageSize,
          current: _ctx.pagination.page,
          total: _ctx.pagination.total
        }, null, 8, ["onChange", "onShowSizeChange", "pageSize", "current", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.statusLogVisible,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.statusLogVisible) = $event)),
      title: "Status Operation Log",
      footer: null,
      width: "850px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          class: "default-self-table-text",
          dataSource: _ctx.statusLogData,
          columns: _ctx.statusLogColumns,
          rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
          pagination: {
        size: _ctx.small,
        total: _ctx.statusLogData.length,
        showTotal: (total) => `Total ${total} items`,
        showSizeChanger: true
      }
        }, null, 8, ["dataSource", "columns", "rowClassName", "pagination"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}